<template>
  <SideBarLayoutContent>
    <template #top-bar>
      <div class="flex w-full flex-row items-center gap-3">
        <h1 class="text-display-small grow">{{ $t('coaching.surveys.title') }}</h1>
        <BaseTextButton
          v-if="canStartSurvey"
          color="tonal"
          size="M"
          icon="add"
          @click="openCreateDialog"
          >{{ $t('coaching.surveys.createAction') }}</BaseTextButton
        >
      </div>
    </template>
    <LoadingWrapper :state="status">
      <ul v-if="surveys.length" class="flex flex-col gap-0.5">
        <li
          v-for="survey in surveys"
          :key="survey.id"
          class="first:[&>div]:rounded-t-large last:[&>div]:rounded-b-large"
        >
          <CoachSurveyPreviewItem :survey="survey" />
        </li>
      </ul>
      <EmptyPage
        v-else
        :title="$t('coaching.surveys.empty.title')"
        :description="$t('coaching.surveys.empty.description')"
        icon="ballot"
      >
        <BaseTextButton
          v-if="canStartSurvey"
          color="tonal"
          icon="add"
          size="M"
          @click="openCreateDialog"
          >{{ $t('coaching.surveys.createAction') }}</BaseTextButton
        >
      </EmptyPage>
    </LoadingWrapper>
  </SideBarLayoutContent>
</template>

<script setup lang="ts">
  import SideBarLayoutContent from '@/core/components/layouts/SideBarLayoutContent.vue'
  import EmptyPage from '@/core/components/empty-states/EmptyPage.vue'
  import { computed } from 'vue'
  import { useCoachSurveys } from '../composables/use-coach-surveys'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import CoachSurveyPreviewItem from '../components/CoachSurveyPreviewItem.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import { usePermission } from '@/core/composables/use-permission'
  import { Permission } from '@/core/models/user'
  import { useRouter } from 'vue-router'

  const { data, status } = useCoachSurveys()

  const surveys = computed(() => data.value ?? [])

  const { can } = usePermission()
  const canStartSurvey = computed(() => can(Permission.COACHING_START_SURVEY))
  const router = useRouter()
  const openCreateDialog = () => {
    router.push({
      query: {
        startCoachSurvey: 'true',
      },
    })
  }
</script>
